module.exports = __webpack_public_path__ + "img/hud_right_bottom_corn.a88b7148.png";